export const ActionTypes = {
  LOADING: "FORGOT_PASSWORD_LOADING",
  ERROR: "FORGOT_PASSWORD_ERROR",
  SUCCESS: "FORGOT_PASSWORD_SUCCESS",
};
